import { CacheProvider }   from "@emotion/react";
import { MantineProvider } from "@mantine/core";

import { isAppleDevice }      from "_common/utils";
import { dark, mantineTheme } from "_styles/theme";

function MantineDarkProvider ( { emotionCache, children } ) {
	const isApple = isAppleDevice ();

	const theme = mantineTheme ( {
		isApple,
		themeColorPalette : dark,
		isMobile          : true,
		darkMode          : true
	} );

	return (
		<MantineProvider
			withGlobalStyles
			emotionCache = { emotionCache }
			forceColorScheme = { "dark" }
			theme = { theme }
		>
			<CacheProvider value = { emotionCache }>
				{children}
			</CacheProvider>
		</MantineProvider>
	);
}
export default MantineDarkProvider;
